import React, { useState } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import StartView from 'views/StartView';
import { useDispatch, useSelector } from 'react-redux';
import { setEmailAddress } from 'store/actions/user';
import { Auth } from 'lib/Amplify';
import PageContainer from 'containers/PageContainer';
import { setAppBusy } from 'store/actions/system';
import { Redirect } from 'react-router';
import useMessages from 'hooks/useMessages';

const fakePasswordToCheckAccount = 'foo';

const StartContainer = ({ history }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const user = useSelector((state) => state.user);
  const { noNetworkMessage } = useMessages();

  const onEmailAddressEntered = (emailAddress, emailAddressValid) => {
    if (!emailAddressValid) {
      setError('Please double check your email address.');
      return;
    }
    dispatch(setEmailAddress(emailAddress));
    dispatch(setAppBusy(true));
    Auth.signIn(emailAddress, fakePasswordToCheckAccount)
      .catch((err) => {
        switch (err.code) {
          case 'NetworkError':
            noNetworkMessage();
            break;
          case 'UserNotFoundException':
            history.push('/signup');
            break;
          case 'UserNotConfirmedException':
            history.push('/verify');
            break;
          default:
            history.push('/login');
        }
      })
      .finally(() => dispatch(setAppBusy(false)));
  };

  if (user) {
    return <Redirect to="/" />;
  }

  return (
    <PageContainer>
      <StartView
        onSubmit={onEmailAddressEntered}
        onChange={emailAddressValid => emailAddressValid && setError(null)}
        error={error}
      />
    </PageContainer>
  );
};

StartContainer.displayName = 'StartContainer';

StartContainer.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default StartContainer;
